import { z } from 'zod';

export const profileInformationSchema = z.object({
  first_name: z
    .string()
    .trim()
    .min(1, 'First name is required.')
    .max(150, 'First name is too long.'),
  last_name: z
    .string()
    .trim()
    .min(1, 'Last name is required.')
    .max(150, 'Last name is too long.'),
  avatar_asset_key: z.string().trim().optional().or(z.literal('')),
});

export type ProfileInformationSchema = z.infer<typeof profileInformationSchema>;
